// Chat function surface. Re-exports every `el.call`-addressable function
// chat components invoke (sendMessage, toggleReaction, uploadAttachment,
// markRead, setupHoverActions, subscribeRealtime, renderMarkdown, plus
// pure helpers). Lives in shared/ so every app picking up shared/context.js
// registers them automatically.

// Pure helpers — no Supabase dependency.
export * from './chatUtils.js'
export * from './messageBody.js'
export * from './messageScans.js'
export * from './htmlToMarkdown.js'
export * from './setupHoverActions.js'
export * from './highlightMentions.js'
export * from './renderMarkdown.js'

// Supabase-backed actions — route through @symbo.ls/sdk-bridge-governance's governance
// client, available in every app that configures sdk-bridge.
export * from './sendMessage.js'
export * from './reactions.js'
export * from './uploadAttachment.js'
export * from './markRead.js'
export * from './markMentionsRead.js'
export * from './subscribeRealtime.js'
export * from './createChannel.js'
export * from './updateChannel.js'
export * from './muteChannel.js'
export * from './messageUser.js'
export * from './searchMessages.js'
export * from './channelActions.js'
export * from './chatBookmarks.js'
